var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame11712770641(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.510742,
    width: 42,
    height: 38,
    rx: 12,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 19.5273H14.2373V23.2188H10.5107V19.5273Z",
    fill: "url(#paint0_linear_3390_1118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 19.5273H14.2373V23.2188H10.5107V19.5273Z",
    fill: "url(#paint1_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 14.7812H14.2373V18.4727H10.5107V14.7812Z",
    fill: "url(#paint2_linear_3390_1118)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 14.7812H14.2373V18.4727H10.5107V14.7812Z",
    fill: "url(#paint3_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 24.2734H14.2373V28H10.5107V24.2734Z",
    fill: "url(#paint4_linear_3390_1118)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 24.2734H14.2373V28H10.5107V24.2734Z",
    fill: "url(#paint5_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 10H14.2373V13.7266H10.5107V10Z",
    fill: "url(#paint6_linear_3390_1118)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5107 10H14.2373V13.7266H10.5107V10Z",
    fill: "url(#paint7_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.292 14.7812H19.9834V18.4727H16.292V14.7812Z",
    fill: "url(#paint8_linear_3390_1118)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.292 14.7812H19.9834V18.4727H16.292V14.7812Z",
    fill: "url(#paint9_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.292 19.5273H19.9834V23.2188H16.292V19.5273Z",
    fill: "url(#paint10_linear_3390_1118)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.292 19.5273H19.9834V23.2188H16.292V19.5273Z",
    fill: "url(#paint11_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0381 19.5273H25.7295V23.2188H22.0381V19.5273Z",
    fill: "url(#paint12_linear_3390_1118)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0381 19.5273H25.7295V23.2188H22.0381V19.5273Z",
    fill: "url(#paint13_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.292 24.2734H19.9834V28H16.292V24.2734Z",
    fill: "url(#paint14_linear_3390_1118)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.292 24.2734H19.9834V28H16.292V24.2734Z",
    fill: "url(#paint15_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0381 24.2734H25.7295V28H22.0381V24.2734Z",
    fill: "url(#paint16_linear_3390_1118)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0381 24.2734H25.7295V28H22.0381V24.2734Z",
    fill: "url(#paint17_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7842 24.2734H31.5107V28H27.7842V24.2734Z",
    fill: "url(#paint18_linear_3390_1118)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7842 24.2734H31.5107V28H27.7842V24.2734Z",
    fill: "url(#paint19_linear_3390_1118)",
    fillOpacity: 0.29
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5107 19.5273H15.2373V23.2188H11.5107V19.5273Z",
    fill: "url(#paint20_linear_3390_1118)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5107 14.7812H15.2373V18.4727H11.5107V14.7812Z",
    fill: "url(#paint21_linear_3390_1118)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5107 24.2734H15.2373V28H11.5107V24.2734Z",
    fill: "url(#paint22_linear_3390_1118)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5107 10H15.2373V13.7266H11.5107V10Z",
    fill: "url(#paint23_linear_3390_1118)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.292 14.7812H20.9834V18.4727H17.292V14.7812Z",
    fill: "url(#paint24_linear_3390_1118)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.292 19.5273H20.9834V23.2188H17.292V19.5273Z",
    fill: "url(#paint25_linear_3390_1118)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0381 19.5273H26.7295V23.2188H23.0381V19.5273Z",
    fill: "url(#paint26_linear_3390_1118)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.292 24.2734H20.9834V28H17.292V24.2734Z",
    fill: "url(#paint27_linear_3390_1118)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0381 24.2734H26.7295V28H23.0381V24.2734Z",
    fill: "url(#paint28_linear_3390_1118)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7842 24.2734H32.5107V28H28.7842V24.2734Z",
    fill: "url(#paint29_linear_3390_1118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3390_1118",
    x1: 13.2383,
    y1: 18.363,
    x2: 12.0128,
    y2: 23.1748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3390_1118",
    x1: 12.374,
    y1: 19.5097,
    x2: 12.374,
    y2: 23.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3390_1118",
    x1: 13.2383,
    y1: 13.6169,
    x2: 12.0128,
    y2: 18.4288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3390_1118",
    x1: 12.374,
    y1: 14.7636,
    x2: 12.374,
    y2: 18.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3390_1118",
    x1: 13.2383,
    y1: 23.098,
    x2: 11.9908,
    y2: 27.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3390_1118",
    x1: 12.374,
    y1: 24.2556,
    x2: 12.374,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3390_1118",
    x1: 13.2383,
    y1: 8.82452,
    x2: 11.9908,
    y2: 13.6766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3390_1118",
    x1: 12.374,
    y1: 9.98216,
    x2: 12.374,
    y2: 13.7266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3390_1118",
    x1: 18.9938,
    y1: 13.6169,
    x2: 17.7581,
    y2: 18.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3390_1118",
    x1: 18.1377,
    y1: 14.7636,
    x2: 18.1377,
    y2: 18.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3390_1118",
    x1: 18.9938,
    y1: 18.363,
    x2: 17.7581,
    y2: 23.1692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3390_1118",
    x1: 18.1377,
    y1: 19.5097,
    x2: 18.1377,
    y2: 23.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3390_1118",
    x1: 24.7399,
    y1: 18.363,
    x2: 23.5042,
    y2: 23.1692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3390_1118",
    x1: 23.8838,
    y1: 19.5097,
    x2: 23.8838,
    y2: 23.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3390_1118",
    x1: 18.9938,
    y1: 23.098,
    x2: 17.736,
    y2: 27.9443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3390_1118",
    x1: 18.1377,
    y1: 24.2556,
    x2: 18.1377,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3390_1118",
    x1: 24.7399,
    y1: 23.098,
    x2: 23.4821,
    y2: 27.9443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3390_1118",
    x1: 23.8838,
    y1: 24.2556,
    x2: 23.8838,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3390_1118",
    x1: 30.5117,
    y1: 23.098,
    x2: 29.2643,
    y2: 27.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3390_1118",
    x1: 29.6475,
    y1: 24.2556,
    x2: 29.6475,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3390_1118",
    x1: 14.2383,
    y1: 18.3861,
    x2: 13.0238,
    y2: 23.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3390_1118",
    x1: 14.2383,
    y1: 13.64,
    x2: 13.0238,
    y2: 18.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3390_1118",
    x1: 14.2383,
    y1: 23.1213,
    x2: 13.002,
    y2: 27.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3390_1118",
    x1: 14.2383,
    y1: 8.84787,
    x2: 13.002,
    y2: 13.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3390_1118",
    x1: 19.9938,
    y1: 13.64,
    x2: 18.7692,
    y2: 18.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3390_1118",
    x1: 19.9938,
    y1: 18.3861,
    x2: 18.7692,
    y2: 23.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3390_1118",
    x1: 25.7399,
    y1: 18.3861,
    x2: 24.5153,
    y2: 23.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3390_1118",
    x1: 19.9938,
    y1: 23.1213,
    x2: 18.7472,
    y2: 27.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3390_1118",
    x1: 25.7399,
    y1: 23.1213,
    x2: 24.4933,
    y2: 27.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3390_1118",
    x1: 31.5117,
    y1: 23.1213,
    x2: 30.2754,
    y2: 27.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11712770641);
export default __webpack_public_path__ + "static/media/Frame 1171277064 (1).a6d7971c12dfa802b7e43c8e6160c00b.svg";
export { ForwardRef as ReactComponent };